// extracted by mini-css-extract-plugin
module.exports = {"Component":"Authentication_Component__vmb4I"};